module.exports = __webpack_public_path__ + "static/register_hb8-d4d6c07f3daae5d15b9d8cecd46ce7f5.pdf";